export enum CustomerFilterType {
  CIRCLES = "CIRCLE_NUMBER",
  SEGMENTS = "EXTERNAL_SEGMENT_ID",
}
